import request from '@/utils/request'
import { ContentTypeJson, ContentTypeForm } from '@/utils/content-type'

export function getRoutes() {
    return request({
        url: '/enterprise/user/getAllRoutes',
        method: 'get'
    })
}

export function getUsers(data) {
    return request({
        url: '/enterprise/user/getUsers',
        method: 'post',
        ...ContentTypeJson(data)
    })
}
//获取审批用户列表
export function getApproveUsers(data) {
    return request({
        url: '/enterprise/user/getApproveUsers',
        method: 'post',
        ...ContentTypeJson(data)
    })
}
export function getRoles(data) {
    return request({
        url: '/enterprise/role/getAllRoles',
        method: 'get',
        params: data
    })
}

//执照类型
export function selectinput(data) {
    return request({
        url: '/dictionary/getMultipleDictionaryInfo',
        method: 'get',
        params: data
    })
}
export function addUser(data) {
    return request({
        url: '/enterprise/user/addUser',
        method: 'post',
        data
        // ...ContentTypeForm(data)
        // ...ContentTypeJson(data)
    })
}
export function setUser(data) {
    return request({
        url: '/enterprise/user/setUser',
        method: 'post',
        data
    })
}
//密码重置
export function recoverPassword(data) {
    return request({
        url: '/enterprise/user/recoverPassword',
        method: 'post',
        data
    })
}
//更新个人信息
export function changeUserInfo(data) {
    return request({
        url: '/enterprise/user/changeUserInfo',
        method: 'post',
        data
    })
}
//实名认证
export function realNameAuthentication(data) {
    return request({
        url: '/enterprise/user/realNameAuthentication',
        method: 'post',
        data
    })
}
//飞手认证
export function droneOperatorAuthentication(data) {
    return request({
        url: '/enterprise/user/droneOperatorAuthentication',
        method: 'post',
        data
    })
}
export function deleteUser(id) {
    return request({
        url: `/enterprise/user/deleteUser`,
        method: 'post',
        ...ContentTypeForm({
            id
        })

    })
}
//审批用户
export function approveUser(data) {
    return request({
        url: `/enterprise/user/approveUser`,
        method: 'post',
        ...ContentTypeForm(data)

    })
}
export function approveDroneOperator(data) {
    return request({
        url: `/enterprise/user/approveDroneOperator`,
        method: 'post',
        ...ContentTypeForm(data)

    })
}
//冻结
export function frozenUser(id) {
    return request({
        url: `/enterprise/user/frozenUser`,
        method: 'post',
        ...ContentTypeForm({
            id
        })

    })
}
//恢复
export function recovery(id) {
    return request({
        url: `/enterprise/user/recoverUser`,
        method: 'post',
        ...ContentTypeForm({
            id
        })

    })
}
//查询部门
export function getDepts(data) {
    return request({
        url: '/enterprise/user/getDepts',
        method: 'get',
        params: data
    })
}
